import { Attachment, Person, Project } from "@/features/auth/graphql/generated";
import { useDimensionsWithScores } from "@/features/people";
import { useAttachments } from "@/shared/hooks";
import { flatten, toNumber, values } from "lodash";

export const useAssessmentTagsData = (project: Project, person: Person) => {
  const { dimensions } = useDimensionsWithScores(
    {
      team_id: project?.team_id ? toNumber(project?.team_id) : undefined,
      position_id: toNumber(project?.id),
      people: [person?.id!].filter(Boolean),
      isLoading: !project.id,
    },
    [person]?.filter(Boolean)
  );

  const { attachments: projectAttachmentsData } = useAttachments(
    {
      position_id: project.id!,
    },
    { skip: !project?.id }
  );

  const { attachments: addonData, loading } = useAttachments(
    {
      person_id: person?.id!,
      position_id: project?.id!,
    },
    { skip: !person?.id }
  );

  const attachments = [
    ...(addonData || []),
    ...(projectAttachmentsData || []),
  ] as Attachment[];

  const tagsData = {
    dimensions: dimensions,
    people: [person]?.filter(Boolean),
    attachments,
  };

  return tagsData;
};
